import { render, staticRenderFns } from "./CpuSoftwareAddOrEditModal.vue?vue&type=template&id=5f5d1cd4&scoped=true"
import script from "./CpuSoftwareAddOrEditModal.vue?vue&type=script&lang=js"
export * from "./CpuSoftwareAddOrEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d1cd4",
  null
  
)

export default component.exports